exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".button-container {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n", "", {"version":3,"sources":["/Users/andreanorman/Projects/ms-andrea-land-react/src/components/src/components/style.scss","/Users/andreanorman/Projects/ms-andrea-land-react/src/components/style.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,oBAAA;CCCD","file":"style.scss","sourcesContent":[".button-container {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n",".button-container {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n"],"sourceRoot":""}]);

// exports
